module.exports = __webpack_public_path__ + "img/sodexo.2cc8dc59.svg";